import axios from 'axios';
import { Config }   from './configActions';
export const FETCH_DUELOS_ABERTOS    = 'FETCH_DUELOS_ABERTOS';
export const FETCH_DUELOS_FINALIZADA = 'FETCH_DUELOS_FINALIZADA';
export const FETCH_DISCIPLINAS       = 'FETCH_DISCIPLINAS';
export const FETCH_ID_DUELO          = 'FETCH_ID_DUELO';
export const ADD_NOVO_DUELO          = 'ADD_NOVO_DUELO';
export const STATUS_DUELO_ABERTO     = 'STATUS_DUELO_ABERTO';

var Authorization = axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem("jwtToken");
 Config();	
// inicio

export function GetDuelosAbertos(usu_id){

	
  const request = axios.get(`/api/duelos/andamento/${usu_id}`,Authorization);  
  
   return{
        type    : FETCH_DUELOS_ABERTOS,
        payload : request

    };

}

export function GetDuelosFinalizados(usu_id){
	
   const request = axios.get(`/api/duelos/finalizados/${usu_id}`,Authorization);  
 
   return{
        type    : FETCH_DUELOS_FINALIZADA,
        payload : request

    };

}

export function getDisciplinaPerfil(use_id){
	

   const request =  axios.get(`/api/disciplinas/professor/listar/${use_id}`,Authorization);

   return{
           type    : FETCH_DISCIPLINAS,
           payload : request
        };
 
}

export function SetIdDuelo(id){

    return{
           type    : FETCH_ID_DUELO,
           payload : id
        };
}

export function SetByIniciarDuelo(usu_id_desafiado,nivel,usu_id_desafiante,cur_id){
	
 
       const request =  axios.post('/api/duelos/iniciar',
                        {
                          due_cod_desafiante : usu_id_desafiante,
                          due_cod_desafiado  : usu_id_desafiado,
                          due_semestre       : nivel,
                          due_cod_curso      : cur_id
                        },Authorization);
  
        return {
                 type    : ADD_NOVO_DUELO,
                 payload : request
               }
}

export function SetByAceitarRecusarDuelo(due_id,acao){
	 return dispatch =>{
       return axios.get(`/api/duelos/aceitar/${due_id}/${acao}`,Authorization);
   }
      //  const dados = {id:due_id,acao:acao}
      //  return {
      //            type    : STATUS_DUELO_ABERTO,
      //            payload : dados
      //          }

}

//fim 



export function GetByDuelosAbertos(usu_id){
	
  return dispatch =>{

       return axios.get(`/api/duelos/andamento/${usu_id}`,Authorization);
  }

}

export function GetByDuelosFinalizados(usu_id){
	
  return dispatch =>{

       return axios.get(`/api/duelos/finalizados/${usu_id}`,Authorization);
  }

}



export function GetUsuarios(cur_id,filtro_nome){
	
  return dispatch =>{

       return axios.get(`/api/usuarios/listar/curso/filtro/${cur_id}/${filtro_nome}`,Authorization);
  }

}







// WEBPACK FOOTER //
// ./src/actions/batalhaAction.js